import { render, staticRenderFns } from "./SetHostCpuReserveResourceDialog.vue?vue&type=template&id=545c9534&"
import script from "./SetHostCpuReserveResourceDialog.vue?vue&type=script&lang=js&"
export * from "./SetHostCpuReserveResourceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports